export interface TCPADisclosureProps {
  partnerName: string;
  supportEmail: string;
  /**
   * Leading clause describing the action the user is taking. The default
   * matches a "yes"/"opt-out" radio above the disclosure; pass a custom
   * lead-in for surfaces with different controls (e.g. a checkbox).
   */
  leadIn?: string;
}

export function TCPADisclosureText({
  partnerName,
  supportEmail,
  leadIn = "By selecting \"yes\" for SMS/Text above",
}: TCPADisclosureProps) {
  return (
    <>
      {leadIn}, I confirm that the number shown above is my mobile phone number, and I agree that {partnerName} and its service provider Kaplan North America, LLC may deliver or cause to be delivered information, including advertisements and telemarketing messages, regarding their educational services by text to my telephone number using automated technology. Consent is not required to receive information or to apply, enroll, or participate in any program. Message &amp; data rates may apply. Message frequency may vary. Reply STOP to unsubscribe or HELP for help or email us at{" "}
      <a href={`mailto:${supportEmail}`}>{supportEmail}</a>.
    </>
  );
}
